import { IModalInstanceService } from 'angular-ui-bootstrap';
import { ActivityInstructionsEditorModal } from './modal';
import type { ModalOptions } from './options';
import { TranslationKeys } from './translation-keys';
import { ActivityInstructionModel } from '../../models/activity';

export class ActivityRecordingInstructionsEditorModal extends ActivityInstructionsEditorModal {

	public open (options: ModalOptions): IModalInstanceService {
		return super.open({
			windowClass: options.inWizard ? 'recording-instructions-modal is-wizard-view' : 'recording-instructions-modal',
			modalData: {
				instructionsType: ActivityInstructionModel.TYPE.RECORDING,
				modalOptions: options,
				translationKeys: {
					modalTitle: 'activity-instructions-editor-modal_recording-instructions-title',
					textInstructionsHeading: 'activity-instructions-editor-modal_text-instructions-heading',
					mediaInstructionsHeading: 'activity-editor-instructions_video-instructions'
				} as TranslationKeys
			}
		});
	}
}
